import { memo } from 'react';
import PropTypes from 'prop-types';
import { brandingUrls } from '../../../config/branding';
import useStatisticsChartTheme from './hooks/useStatisticsChartTheme';

const MARKS_PER_ROW = 4;

/** 5 行平行 + 奇偶行交错，缩小截图可裁剪的空白区 */
const WATERMARK_ROWS = [
	{ className: 'row--1', stagger: false },
	{ className: 'row--2', stagger: true },
	{ className: 'row--3', stagger: false },
	{ className: 'row--4', stagger: true },
	{ className: 'row--5', stagger: false },
];

/** 统计图容器：平行斜向品牌 wordmark 水印 */
const StatisticsChartFrame = ({ children, className = '', style, fillSlot = false }) => {
	const { isLight } = useStatisticsChartTheme();
	const logoSrc = isLight ? brandingUrls.wordmarkPrimary : brandingUrls.wordmarkWhite;
	const frameStyle = fillSlot
		? {
				display: 'flex',
				flexDirection: 'column',
				flex: '1 1 auto',
				minHeight: 0,
				height: '100%',
				width: '100%',
				...style,
			}
		: style;

	return (
		<div
			className={['statistics-chart-frame', fillSlot ? 'statistics-chart-frame--fill-slot' : null, className].filter(Boolean).join(' ')}
			style={frameStyle}
		>
			<div className='statistics-chart-frame__chart'>{children}</div>
			<div className='statistics-chart-frame__watermark-layer' aria-hidden='true'>
				{WATERMARK_ROWS.map(({ className: rowClass, stagger }) => (
					<div
						key={rowClass}
						className={[
							'statistics-chart-frame__watermark-row',
							rowClass,
							stagger ? 'statistics-chart-frame__watermark-row--stagger' : null,
						]
							.filter(Boolean)
							.join(' ')}
					>
						{Array.from({ length: MARKS_PER_ROW }, (_, index) => (
							<img
								key={index}
								className='statistics-chart-frame__mark'
								src={logoSrc}
								alt=''
								draggable={false}
							/>
						))}
					</div>
				))}
			</div>
		</div>
	);
};

StatisticsChartFrame.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	style: PropTypes.object,
	fillSlot: PropTypes.bool,
};

export default memo(StatisticsChartFrame);
